"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _components = require("@folio/stripes/components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RefdataButtons = props => {
  // Render the right number of buttons:
  const {
    labelTranslations,
    lockColumns,
    maxCols = 4
  } = props;
  const intl = (0, _reactIntl.useIntl)();

  // maxCols can be any of 1,2,3 or 4. Anything outside of this should be disregarded and default to 4.
  const maximumColumns = [1, 2, 3, 4].includes(maxCols) ? maxCols : 4;
  const buttonRender = (dataOptions, dynamicColumnWidth) => {
    // This accepts a SORTED list of dataoptions.
    const {
      input
    } = props;
    const numberOfButtons = dataOptions.length;
    return dataOptions.map(option => {
      const buttonProps = {
        'checked': input.value === option.value,
        'fullWidth': true,
        'label': labelTranslations ? intl.formatMessage({
          id: `${labelTranslations.key}.${option.value}`,
          defaultMessage: option.label
        }) : option.label,
        'marginBottom0': true,
        'onChange': () => input.onChange(option.value),
        'value': option.value
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: dynamicColumnWidth ? 12 / numberOfButtons : 12 / maximumColumns,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.RadioButton, {
          ...buttonProps
        })
      }, `${input.name}:${option.id}`);
    });
  };
  const returnRows = dataOptions => {
    const sortedDataOptions = dataOptions.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
    const arrayLength = sortedDataOptions.length;
    if (!lockColumns && arrayLength <= maximumColumns) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Row, {
        children: buttonRender(sortedDataOptions, true)
      });
    }
    const rowsNeeded = Math.ceil(sortedDataOptions.length / maximumColumns);
    const chunkedDataOptions = [];
    for (let i = 0; i < rowsNeeded; i++) {
      chunkedDataOptions.push(sortedDataOptions.slice(i * maximumColumns, i * maximumColumns + maximumColumns));
    }
    return chunkedDataOptions.map((cdo, index) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Row, {
        children: buttonRender(cdo, false)
      }, `${props.input.name}:row${index}`);
    });
  };
  return returnRows(props.dataOptions);
};
RefdataButtons.propTypes = {
  dataOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })),
  input: _propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    onChange: _propTypes.default.func.isRequired
  }).isRequired
};
var _default = exports.default = RefdataButtons;